import { createContext } from 'react';

interface ValorInscricaoContext {
  inscricao: any,
  etapas: any;
  originResponse?: any;
  originError?: any;
}

const InscricaoContext = createContext({} as ValorInscricaoContext)
export default InscricaoContext
